class SimpleStorage {
  constructor(private readonly backend: Storage) {}

  getItem<T>(key: string): T | undefined {
    const value = this.backend.getItem(key);

    if (!value) {
      return undefined;
    }

    try {
      return JSON.parse(value).value;
    } catch {
      console.warn(`corrupt storage value: ${key} = ${value}`);
      return undefined;
    }
  }

  setItem<T>(key: string, value: T): void {
    this.backend.setItem(key, JSON.stringify({ value }));
  }

  delete(key: string): void {
    this.backend.removeItem(key);
  }
}

export const simpleStorage = new SimpleStorage(window.localStorage);

export const simpleSessionStorage = new SimpleStorage(window.sessionStorage);
